module.exports = __webpack_public_path__ + "img/correct.0b6151d3.svg";